import axios from "axios";
import { API_URL } from "../../action/constant";
import { ActionTypes } from "./action_types";
import { getRandomAvatar } from "../../action/functions";

export const login = (data) => async(dispatch) => {
    var config = {
        method: 'post',
        url:`${API_URL}user/login`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
    };

    let resp = await axios(config)
    .then((response) => {
        dispatch({
            type: ActionTypes.LOGIN_USER,
            payload: {
                ...response.data,
                profile_picture: getRandomAvatar(),
            }
        })
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const register = (data) => async(dispatch) => {
    var config = {
        method: 'post',
        url:`${API_URL}user/register`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
    };

    let resp = await axios(config)
    .then((response) => {
        dispatch({
            type: ActionTypes.REGISTER_USER,
            payload: {
                ...response.data,
                profile_picture: getRandomAvatar(),
            }
        })
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to create your account at the moment'
            }
        }
    })

    return resp;
}

export const registerSocial = (data) => async(dispatch) => {
    var config = {
        method: 'post',
        url:`${API_URL}user/register-social`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
    };

    let resp = await axios(config)
    .then((response) => {
        dispatch({
            type: ActionTypes.REGISTER_USER,
            payload: {
                ...response.data,
                profile_picture: getRandomAvatar(),
            }
        })
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to create your account at the moment'
            }
        }
    })

    return resp;
}

export const loginSocial = (data) => async(dispatch) => {
    var config = {
        method: 'post',
        url:`${API_URL}user/login-social`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
    };

    let resp = await axios(config)
    .then((response) => {
        dispatch({
            type: ActionTypes.LOGIN_USER,
            payload: {
                ...response.data,
                profile_picture: getRandomAvatar(),
            }
        })
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const verifyUser = (data) => async(dispatch) => {
    var config = {
        method: 'post',
        url:`${API_URL}verify/email`,
        headers: {
          'Content-Type': 'application/json'
        },
        data: data
    };

    let resp = await axios(config)
    .then((response) => {
        dispatch({
            type: ActionTypes.VERIFY_USER,
            payload: {
                email_verified: true,
            }
        })
        return {
            status: true,
            data: response.data
        }
    })
    .catch((error) => {
        if (error.response && error.response.data.error) {
            if (typeof(error.response.data.message) === 'object') {
                let error_msg = Object.values(error.response.data.message)[0];
                if (typeof(error_msg) === 'object') {
                    return {
                        status: false,
                        message: error_msg[0]
                    }
                }else {
                    return {
                        status: false,
                        message: error_msg
                    }
                }
            }else {
                return {
                    status: false,
                    message: error.response.data.message
                }
            }
        }else {
            return {
                status: false,
                message: 'Unable to connect to server, try again later.'
            }
        }
    })

    return resp;
}

export const logout = () => async(dispatch) => {
    dispatch({
        type: ActionTypes.LOGOUT_USER
    });
}